import React, { useEffect, useState } from "react";
const Price = ({ value, isNegative, className }) => {
  const [displayPrice, setDisplayPrice] = useState(null);
  useEffect(() => {
    let cost = value / 100;
    if (!cost) {
      cost = 0;
    }
    setDisplayPrice((Math.round(cost * 100) / 100).toFixed(2));
  }, [value]);
  return (
    <span className={className}>
      {isNegative ? "-" : ""}£{displayPrice}
    </span>
  );
};

export default Price;
